export default __webpack_public_path__ + "static/media/img-forgotpass.bc5ae85b.svg";